var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VWrapper',{attrs:{"title":"error.notFound"}},[_vm._v(" "+_vm._s(_vm.$t('error.notFoundText'))+" "),_c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('VBtn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push({ name: 'start' })}}},[_vm._v(_vm._s(_vm.$t('error.goHome')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }